// Real Iron Talon Farm photos.
// Two sources:
// 1. Catherine's personal photography (the new gold) — served from /photos/...
// 2. Cottage interior/exterior shots still pulled from the previous Squarespace CDN
//    until new cottage photography is taken.
const CDN = "https://images.squarespace-cdn.com/content/v1/6712908150091e149546b5e6";

// Local photos (Catherine's own work)
const P = "/photos";

export const IMAGES = {
  imgGranary1: `${P}/uploads/granary-1.jpg`,
  imgGranary2: `${P}/uploads/granary-2.jpg`,
  imgGranary3: `${P}/uploads/granary-3.jpg`,
  imgGranary4: `${P}/uploads/granary-4.jpg`,
  imgGranaryExt: `${P}/uploads/granary-ext.jpg`,       // NEW — red cottage exterior with deck
  imgGranary5: `${P}/uploads/granary-5.jpg`,           // NEW — corrugated shower + toilet
  imgCattailInt: `${P}/uploads/cattail-interior.png`,  // NEW — blue quilt + corrugated wall bedroom
  // User-named photos (Feb 2026 upload)
  imgCattailOutsideUser: `${P}/uploads/cattail-outside-user.jpg`,   // small red cottage w/ green roof
  imgCattailIntUser1:    `${P}/uploads/cattail-interior-user-1.jpg`, // bed w/ wood stove + green chair
  imgCattailIntUser2:    `${P}/uploads/cattail-interior-user-2.jpg`, // bed w/ dresser + oval braided rug
  imgGardenCottageUser:  `${P}/uploads/garden-cottage-user.jpg`,     // red multi-story house w/ garden path
  // User-labeled photos (Feb 2026 upload — creekside + trail set)
  imgTrailNature:        `${P}/uploads/trail-nature.jpg`,            // grass path w/ willow trees + power poles
  imgCreeksideExterior:  `${P}/uploads/creekside-exterior.jpg`,      // small screen-porch cottage w/ boardwalk approach
  imgCreeksideBoardwalk: `${P}/uploads/creekside-boardwalk.jpg`,     // boardwalk over creek in woods
  imgCreeksideCreek:     `${P}/uploads/creekside-creek.jpg`,         // creek in the woods
  imgCreeksideShower:    `${P}/uploads/creekside-shower-hires.png`,  // outdoor shower + screen porch (red) — HD
  // Feb 2026 second batch — user-labeled amenity + cottage additions
  imgBarnKitchen:        `${P}/uploads/barn-kitchen-user.png`,       // wood-beam kitchen w/ star, hanging bulbs
  imgCattailFront:       `${P}/uploads/cattail-front-user.png`,      // straight-on red cottage front, green roof
  imgCornCribSaunaHD:    `${P}/uploads/corn-crib-sauna-user.png`,    // infrared sauna interior — clean, no reflections
  imgFlowerRed:          `${P}/uploads/flower-red-user.jpg`,         // red crocosmia flowers close-up
  // Feb 2026 third batch — loft, reflection cottage, wellness studio
  imgLoftExterior:       `${P}/uploads/loft-exterior-user.jpg`,      // red cottage w/ white stairs to deck
  imgReflectionCottage6: `${P}/uploads/reflection-cottage-6.jpg`,    // small red shed w/ green-roof + flowers
  imgReflectionCottage7: `${P}/uploads/reflection-cottage-7.jpg`,    // red cottage courtyard w/ brick path
  imgWellnessStudioLounge: `${P}/uploads/wellness-studio-user.jpg`,  // wooden lounge w/ leather sofas
  // Feb 2026 fourth batch — loft additions + garden shots
  imgLoftFrontPorch:     `${P}/uploads/loft-courtyard.jpg`,          // red cottage front porch w/ rocking chair (actual loft cover)
  imgGardenBridge:       `${P}/uploads/loft-front-porch.png`,        // wooden foot-bridge in ferns (garden feature)
  imgVegRaisedBeds:      `${P}/uploads/flower-garden-bridge.jpg`,    // raised-bed vegetable garden w/ red sheds
  imgVegGardenEdit:      `${P}/uploads/veg-garden-edit.png`,         // flagstone path + reclaimed-wood garden gate
  // Feb 2026 fifth batch — barn kitchen 2 + hilltop sunset
  imgBarnKitchen2:       `${P}/uploads/barn-kitchen-2.png`,          // wood-panel kitchen w/ rusty star, stove, mugs
  imgHilltopSunsetBenches: `${P}/uploads/hilltop-sunset-benches.jpg`, // sunset benches on hilltop
  // Feb 2026 sixth batch — panoramic + gallery-worthy scenics
  imgFarmOverviewAerial: `${P}/uploads/farm-overview-aerial.jpg`,    // aerial farm panorama w/ red buildings
  imgGardenCottageBack: `${P}/uploads/garden-cottage-back.jpg`,      // Garden cottage back garden w/ birdbath + path
  imgSkylineClouds:     `${P}/uploads/skyline-clouds.webp`,          // atmospheric clouds over mountain silhouette
  imgSkylineSunsetField: `${P}/uploads/skyline-sunset-field.webp`,   // sunset over rolling hills, field foreground
  // Feb 2026 seventh batch — MLS-quality seasonal shots
  imgVegGardenHenDen:    `${P}/uploads/veg-garden-hen-den.webp`,     // vegetable garden raised beds w/ "The Hen Den"
  imgBarnPondSummer:     `${P}/uploads/barn-pond-summer.webp`,       // barn w/ pond + cattails, elevated deck (summer)
  imgBarnWinterSide:     `${P}/uploads/barn-winter-side.webp`,       // barn side view w/ stone foundation (winter)
  // Feb 2026 eighth batch — Cottage on the Hill deep dive (5 shots)
  imgHilltopIntCabin:    `${P}/uploads/hilltop-int-cabin.webp`,      // full cabin interior — bed, kitchenette, door to porch
  imgHilltopSnowyWarm:   `${P}/uploads/hilltop-snowy-warm.webp`,     // snowy exterior + outhouse, warm sunset sky
  imgHilltopPorchSummer: `${P}/uploads/hilltop-porch-summer.webp`,   // summer view from porch — picnic table + fire pit
  imgHilltopIntBed:      `${P}/uploads/hilltop-int-bed.png`,         // bed close-up w/ propane heater on wall
  // Feb 2026 ninth batch — user-labeled amenity/cottage additions
  imgGymUser:            `${P}/uploads/gym-user.webp`,               // gym w/ dumbbells + wood-stove + mirror
  imgCornCribSauna2:     `${P}/uploads/corn-crib-sauna-2.webp`,      // infrared sauna alt angle w/ towels
  imgGranaryWoodStove:   `${P}/uploads/granary-wood-stove.webp`,     // green wood stove w/ leather chair (granary)
  imgBarnOfficeSnowyDeck: `${P}/uploads/barn-office-snowy-deck.webp`, // snowy bistro deck view from barn office
  // Feb 2026 tenth batch — hero overview + creekside detail + wellness yoga
  imgOverviewHero:       `${P}/uploads/overview-hero.png`,           // property overview — barn + red cottage + pond + chairs
  imgCreeksideShed:      `${P}/uploads/creekside-shed-exterior.jpeg`, // small red-shed cottage exterior (creekside)
  imgCreeksideIntBed:    `${P}/uploads/creekside-int-bed.png`,       // blue-striped bed nook + floral chair
  imgCreeksideIntRocker: `${P}/uploads/creekside-int-rocker.webp`,   // floral rocker + heater + mirror
  imgWellnessYoga:       `${P}/uploads/wellness-yoga.png`,           // yoga studio w/ mats + wood stove + snow
  // Feb 2026 eleventh batch — barn/pond/hilltop/granary/hen-den HD additions
  imgBarnEchinacea:      `${P}/uploads/barn-echinacea.webp`,         // red barn w/ pink echinacea + picket fence
  imgHilltopWindowWinter: `${P}/uploads/hilltop-window-winter.jpeg`, // winter view through window w/ rocking chair
  imgGranaryPhoneCottage: `${P}/uploads/granary-phone-cottage.png`,  // red barn + phone cottage outbuilding path
  imgVegGardenHenDenHD:  `${P}/uploads/veg-garden-hen-den-hd.png`,   // Hen Den vegetable garden (high-res replacement)
  imgOverviewPondBench:  `${P}/uploads/overview-pond-bench.jpeg`,    // bench under tree by pond w/ red canoe + barn
  // Feb 2026 twelfth batch — creekside shed, barn deck, barn across pond, HD kitchen, barn+pond
  imgCreeksideShedTable: `${P}/uploads/creekside-shed-table.jpeg`,   // small red shed w/ picnic table + benches
  imgBarnDeckChairs:     `${P}/uploads/barn-deck-chairs.png`,        // elevated deck w/ adirondack chairs + barn doors
  imgBarnAcrossPond:     `${P}/uploads/barn-across-pond.png`,        // barn from across pond, framed by trees
  imgBarnKitchenHD:      `${P}/uploads/barn-kitchen-hd.png`,         // high-res kitchen w/ tin star + mugs (replaces imgBarnKitchen)
  imgBarnPondCattails:   `${P}/uploads/barn-pond-cattails.png`,      // barn w/ pond in front, cattails, red chairs, deck
  // Feb 2026 thirteenth batch
  imgCreeksideCoverNew:  `${P}/uploads/creekside-cover-new.png`,     // screened cabin w/ path (new Creekside cover)
  imgOverviewSnowyMountain: `${P}/uploads/overview-snowy-mountain.webp`, // snowy mountain landscape, distant sheds
  imgOverviewSnowyPond:  `${P}/uploads/overview-snowy-pond.webp`,    // snowy pond w/ red canoe, bench, barn
  // Feb 2026 fourteenth batch — sunflowers + oats + garden pergola HD
  imgSunflowersMountain: `${P}/uploads/sunflowers-mountain.jpg`,     // sunflower rows w/ mountain range
  imgSunflowersDusk:     `${P}/uploads/sunflowers-dusk.jpg`,         // sunflower field at pink dusk
  imgOatsDuskField:      `${P}/uploads/oats-dusk-field.jpg`,         // oat field at pink dusk
  imgVegGardenPergolaHD: `${P}/uploads/veg-garden-pergola-hd.png`,   // flagstone pergola garden HD
  imgHilltopBenches: `${P}/uploads/hilltop-benches.jpg`,// NEW — two benches at sunset
  imgHilltopView: `${P}/uploads/hilltop-view.jpg`,     // NEW — blue sky rolling hills view
  // Feb 2026 fifteenth batch — walk-the-land + winter overview + hilltop snow
  imgWalkTheLand2:       `${P}/uploads/walk-the-land-2.jpg`,       // dreamy pink dusk over misty hills w/ oat field
  imgHilltop6:           `${P}/uploads/hilltop-6.jpeg`,            // snowy hilltop picnic table w/ mountain view
  imgOverviewSnowyBarn:  `${P}/uploads/overview-snowy-barn.webp`,  // full red barn complex in fresh snow
  // Feb 2026 sixteenth batch — chickens, heron, wider pond + garden-cottage overviews
  imgChickens:           `${P}/uploads/chickens.png`,              // two black chickens by the culvert rocks
  imgHeronWillow:        `${P}/uploads/walk-the-land-5-heron.png`, // great blue heron under willow branches
  imgOverviewCattail3:   `${P}/uploads/overview-cattail-3.png`,    // barn + red house + cattails wide view
  // Feb 2026 seventeenth batch — bath house + pollinators
  imgBathhouse1:         `${P}/uploads/barn-bathhouse-1.jpg`,      // full bath: corrugated silver walls, shower, toilet, sink
  imgBathhouse2:         `${P}/uploads/barn-bathhouse-2.jpg`,      // full bath: shower curtains, toilet, wood-frame sink
  imgBathhouseSink:      `${P}/uploads/barn-bathhouse-sink.jpg`,   // galvanized tub sink on burnished plywood
  imgSwallowtailZinnia:  `${P}/uploads/walk-the-land-6-butterfly.jpg`, // tiger swallowtail on pink zinnia
  imgBumblebeeZinnia:    `${P}/uploads/walk-the-land-7-bee.jpg`,       // bumblebee on red zinnia close-up
  // ===== TARGETED PLACEMENTS (Catherine's specific IMG_ references, July 2026) =====
  imgHillDope:         `${P}/drive/d-165.jpg`, // IMG_5169 — hero shot, hilltop
  imgFarmBanner:       `${P}/drive/d-122.jpg`, // IMG_5144 — skyline from the hill (Farm banner)
  imgRestFlower:       `${P}/drive/d-044.jpg`, // IMG_5057 — flower for "Rest" pillar
  // Gallery — "Walk the Land" photos (property/gardens/moments)
  imgGal01: `${P}/drive/d-217.jpg`, // IMG_5050
  imgGal02: `${P}/drive/d-084.jpg`, // IMG_5437
  imgGal03: `${P}/drive/d-038.jpg`, // IMG_5718
  imgGal04: `${P}/drive/d-162.jpg`, // IMG_5768
  imgGal05: `${P}/drive/d-186.jpg`, // IMG_6292
  imgGal06: `${P}/drive/d-019.jpg`, // IMG_6440
  imgGal07: `${P}/drive/d-010.jpg`, // IMG_6471
  imgGal08: `${P}/drive/d-230.jpg`, // IMG_6507
  imgGal09: `${P}/drive/d-139.jpg`, // IMG_6514
  imgGal10: `${P}/drive/d-179.jpg`, // IMG_6629
  imgGal11: `${P}/drive/d-190.jpg`, // IMG_6633
  imgGal12: `${P}/drive/d-224.jpg`, // IMG_6715
  imgGal13: `${P}/drive/d-023.jpg`, // IMG_6736
  imgCattailView:      `${P}/drive/d-238.jpg`, // IMG_5365 — pond view from Cattail Cottage
  imgPondFeature:      `${P}/drive/d-136.jpg`, // IMG_5632 — dramatic cattails/pond
  imgBarnKitchen1:     `${P}/drive/d-145.jpg`, // IMG_6060 — barn kitchen w/ pendants
  imgBarnKitchen2:     `${P}/drive/d-216.jpg`, // IMG_6062 — kitchen w/ star + stove
  imgSauna1:           `${P}/drive/d-072.jpg`, // IMG_6367 — corn crib interior
  imgSauna2:           `${P}/drive/d-030.jpg`, // IMG_6368 — corn crib interior
  imgGardenCott1:      `${P}/drive/d-197.jpg`, // IMG_6753 — Garden Cott bedroom
  imgGardenCott2:      `${P}/drive/d-025.jpg`, // IMG_6754 — Garden Cott bedroom
  imgGardenCott3:      `${P}/drive/d-018.jpg`, // IMG_6759 — Garden Cott second bedroom
  imgGardenCott4:      `${P}/drive/d-185.jpg`, // IMG_6760 — Garden Cott bathroom
  imgLoftBath:         `${P}/drive/d-196.jpg`, // IMG_6776 — Loft bathroom w/ clawfoot tub
  imgLoftKitchen:      `${P}/drive/d-079.jpg`, // IMG_6780 — Loft kitchen
  imgLoftInterior:     `${P}/drive/d-172.jpg`, // IMG_6784 — Loft interior
  imgHillCottExt:      `${P}/drive/d-131.jpg`, // IMG_6833 — Hilltop cottage exterior
  imgHillCottPath:     `${P}/drive/d-005.jpg`, // IMG_6834 — Hilltop path/context
  imgHillView:         `${P}/drive/d-173.jpg`, // IMG_6865 — Hilltop view + skyline ref
  imgGymLogo:          `${P}/drive/d-001.jpg`, // IMG_6889 — Iron Talon logo on gym
  imgPropertyOverview: `${P}/drive/d-194.jpg`, // IMG_6933 — main property overview
  imgFlowers1:         `${P}/drive/d-066.jpg`, // IMG_7361 — flower garden
  imgFlowers2:         `${P}/drive/d-035.jpg`, // IMG_7362 — flower garden
  imgFlowers3:         `${P}/drive/d-047.jpg`, // IMG_7363 — flower garden
  imgFlowers4:         `${P}/drive/d-008.jpg`, // IMG_7367 — flower garden

  // ===== DRIVE FOLDER BATCH (July 2026) — pond, bunny, barn interior & landscape shots =====
  drivePond01: `${P}/drive/d-019.jpg`,
  drivePond02: `${P}/drive/d-024.jpg`,
  drivePond03: `${P}/drive/d-026.jpg`,
  drivePond04: `${P}/drive/d-029.jpg`,
  drivePond05: `${P}/drive/d-030.jpg`,
  drivePond06: `${P}/drive/d-034.jpg`,
  drivePond07: `${P}/drive/d-048.jpg`,
  drivePond08: `${P}/drive/d-092.jpg`,
  drivePond09: `${P}/drive/d-093.jpg`,
  drivePond10: `${P}/drive/d-111.jpg`,
  drivePond11: `${P}/drive/d-136.jpg`,
  drivePond12: `${P}/drive/d-179.jpg`,
  driveBunny01: `${P}/drive/d-016.jpg`,
  driveBunny02: `${P}/drive/d-025.jpg`,
  driveBunny03: `${P}/drive/d-044.jpg`,
  driveBunny04: `${P}/drive/d-005.jpg`,
  driveView01: `${P}/drive/d-008.jpg`,
  driveView02: `${P}/drive/d-035.jpg`,
  driveView03: `${P}/drive/d-046.jpg`,
  driveView04: `${P}/drive/d-165.jpg`,   // dramatic sunset over hills
  driveView05: `${P}/drive/d-169.jpg`,   // meadow with single tree, cloudy sky
  // Barn — actual interior shots showing kitchen / bar / gathering area
  driveBarnInt01: `${P}/drive/d-137.jpg`,
  driveBarnInt02: `${P}/drive/d-140.jpg`,
  driveBarnInt03: `${P}/drive/d-141.jpg`,
  driveBarnInt04: `${P}/drive/d-145.jpg`,
  // Barn exteriors
  driveBarnExt01: `${P}/drive/d-104.jpg`,  // red barn + pond
  driveBarnExt02: `${P}/drive/d-117.jpg`,  // red barn in snow with deck
  driveBarnExt03: `${P}/drive/d-138.jpg`,  // wide red barn complex + hills

  // ===== NEW BATCH (June 2026 — Catherine's latest uploads) =====
  // Views & landscapes from the Iron Talon property
  newView01: `${P}/new/new-04.jpg`,         // lone tree in field, bright sky
  newView02: `${P}/new/new-05.jpg`,         // lone tree, blue sky
  newView03: `${P}/new/new-11.jpg`,         // sunset rolling landscape, warm hues
  newView04: `${P}/new/new-12.jpg`,         // panoramic, wispy clouds at sunset
  newView05: `${P}/new/new-13.jpg`,         // panoramic with dramatic sky
  newView06: `${P}/new/new-14.jpg`,         // wide fisheye grassy field
  newView07: `${P}/new/new-15.jpg`,         // silhouetted hills at twilight
  newView08: `${P}/new/new-16.jpg`,         // dusk hilly landscape
  newView09: `${P}/new/new-17.jpg`,         // grassy field with picnic table
  newView10: `${P}/new/new-18.jpg`,         // broad fields, dramatic sky
  newView11: `${P}/new/new-19.jpg`,         // rolling hills with picnic table + dog
  newView12: `${P}/new/new-24.jpg`,         // picnic table + tree + distant landscape
  // Bunny in his element
  newBunny01: `${P}/new/new-02.jpg`,        // puppy in green vest on porch
  newBunny02: `${P}/new/new-03.jpg`,        // puppy in green vest on porch
  newBunny03: `${P}/new/new-08.jpg`,        // walking up wooded hillside
  newBunny04: `${P}/new/new-20.jpg`,        // sleeping on weathered picnic table
  newBunny05: `${P}/new/new-22.jpg`,        // sleeping on picnic table
  newBunny06: `${P}/new/new-23.jpg`,        // sitting on green grass in sunlight
  newBunny07: `${P}/new/new-25.jpg`,        // on picnic table
  newBunny08: `${P}/new/new-27.jpg`,        // on picnic table
  newBunny09: `${P}/new/new-29.jpg`,        // on wooden surface looking up
  newBunny10: `${P}/new/new-30.jpg`,        // by the pond with reeds
  newBunny11: `${P}/new/new-32.jpg`,        // green vest on wooden deck
  // Gardens (early spring crocuses + snowdrops)
  newGarden01: `${P}/new/new-06.jpg`,       // white snowdrops
  newGarden02: `${P}/new/new-07.jpg`,       // white snowdrops
  newGarden03: `${P}/new/new-09.jpg`,       // purple crocuses
  newGarden04: `${P}/new/new-10.jpg`,       // purple crocuses
  newGarden05: `${P}/new/new-31.jpg`,       // purple-and-white striped crocuses
  // The Barn in snow
  newBarn01: `${P}/new/new-01.jpg`,         // two-story red barn in snowy landscape

  // ===== October 2026 additions (owner uploads) =====
  oct26BarnKitchenBar:   `${P}/new-oct26/barn-kitchen-bar.png`,     // open kitchen with bar stools, star wall decor
  oct26BarnPorchFlag:    `${P}/new-oct26/barn-porch-flag.png`,      // covered porch with couches, flag, ceiling fan
  oct26BarnPorchCouches: `${P}/new-oct26/barn-porch-couches.png`,   // covered porch lounge, Jenga, open to deck
  oct26FarmSkyline:      `${P}/new-oct26/farm-skyline-field.jpg`,   // oat field with Blue Mountain ridgeline
  oct26BunnySkyline:     `${P}/new-oct26/bunny-skyline-sunset.png`, // Bunny in field at sunset with mountains
  oct26FarmDeer:         `${P}/new-oct26/farm-deer.jpg`,            // buck silhouette at dusk in tall grass
  oct26FarmFlag:         `${P}/new-oct26/farm-flag.jpg`,            // US flag in Queen Anne's lace meadow
  oct26FarmHillside:     `${P}/new-oct26/farm-hillside.jpg`,        // green hillside under big cloudy sky
  oct26FarmLeaves:       `${P}/new-oct26/farm-leaves.jpg`,          // red-copper coleus leaves in garden
  oct26BeeOnZinnia:      `${P}/new-oct26/bee-on-zinnia.jpg`,        // bumblebee on red zinnia
  oct26HilltopSunset:    `${P}/new-oct26/hilltop-sunset.jpg`,       // Hilltop ridge sunset w/ tree + fire pit area
  oct26HilltopFirepit:   `${P}/new-oct26/hilltop-firepit.jpg`,      // fire pit lit at dusk w/ ring of benches
  oct26GardenColeus:     `${P}/new-oct26/garden-coleus.webp`,       // vibrant coleus + impatiens garden w/ trellis
  oct26Anemones:         `${P}/new-oct26/anemones.jpg`,             // white Japanese anemones in bloom
  oct26SwallowtailZinnia:`${P}/new-oct26/swallowtail-zinnia.jpg`,   // tiger swallowtail on pink zinnia

  // ===== HERO + LANDSCAPES (Catherine's photos) =====
  heroHome: `${P}/IMG_5169.JPEG`,        // dramatic sunset with sunburst — Catherine's pick
  heroHomeAlt: `${P}/IMG_5144.JPEG`,
  heroFarm: `${P}/IMG_2122.JPEG`,        // sunset over rolling hills
  heroSunset2: `${P}/IMG_2124.JPEG`,
  heroSunset3: `${P}/IMG_5170.JPEG`,
  heroSunset4: `${P}/IMG_5169.JPEG`,
  heroSunset5: `${P}/IMG_2126.JPEG`,
  heroSunset6: `${P}/IMG_5750.JPEG`,
  cloudsDramatic: `${P}/IMG_2257.JPEG`,

  // ===== BUNNY 🐾 (Catherine's resident farm dog) =====
  bunnyPortrait: `${P}/IMG_6343.JPEG`,   // sitting by the pond, looking at camera
  bunnyByPond: `${P}/IMG_6336.JPEG`,
  bunnyByPond2: `${P}/IMG_6339.JPEG`,
  bunnyRunning: `${P}/IMG_6292.JPEG`,    // walking up a hill at distance
  bunnySleeping: `${P}/IMG_5249.JPEG`,   // sleeping on picnic table
  bunnySleeping2: `${P}/IMG_5254.JPEG`,
  bunnyAtField: `${P}/IMG_6241.JPEG`,
  bunnyLeaves: `${P}/IMG_5050.JPEG`,     // running through leaves
  bunnyPaw: `${P}/IMG_4623.JPEG`,        // paw print in snow
  bunnyPondEdge: `${P}/IMG_6632.JPEG`,
  bunnyAtPondShore: `${P}/IMG_6631.JPEG`,

  // ===== GARDEN / DETAILS (Catherine's photos) =====
  poppy: `${P}/IMG_6507.JPEG`,           // vivid orange poppy
  allium: `${P}/IMG_6514.JPEG`,          // purple allium spheres
  bleedingHearts: `${P}/IMG_6633.JPEG`,  // bleeding hearts against red wall
  bleedingHearts2: `${P}/IMG_6634.JPEG`,
  lilac: `${P}/IMG_6129.JPEG`,           // lilac blossoms
  lilac2: `${P}/IMG_6130.JPEG`,
  crocuses: `${P}/IMG_5057.JPEG`,
  crocuses2: `${P}/IMG_5058.JPEG`,
  crocuses3: `${P}/IMG_5359.JPEG`,
  primroses: `${P}/IMG_5959.JPEG`,
  tulip: `${P}/IMG_5949.JPEG`,
  tulip2: `${P}/IMG_5950.JPEG`,
  blueFlowers: `${P}/IMG_5768.JPEG`,
  flowerBouquet: `${P}/IMG_5675.JPEG`,
  raisedBedHarvest: `${P}/IMG_6480.JPEG`,
  raisedBedLettuce: `${P}/IMG_6389.JPEG`,
  raisedBedLettuce2: `${P}/IMG_6459.JPEG`,
  fungi: `${P}/IMG_5678.JPEG`,
  groundCover: `${P}/IMG_6139.JPEG`,
  phlox: `${P}/IMG_5952.JPEG`,

  // ===== POND / WATER (Catherine's photos) =====
  pondClearStream: `${P}/IMG_4945.JPEG`,
  pondWithStructure: `${P}/IMG_5343.JPEG`,
  pondReeds: `${P}/IMG_5366.JPEG`,
  pondReeds2: `${P}/IMG_5367.JPEG`,
  pondCattails: `${P}/IMG_5632.JPEG`,
  pondAlgae: `${P}/IMG_6629.JPEG`,

  // ===== ATMOSPHERE =====
  campfire: `${P}/IMG_4914.JPEG`,
  natGeo: `${P}/IMG_5742.JPEG`,          // vintage Nat Geo (atmospheric)
  outhouse: `${P}/IMG_3502.JPEG`,
  outhouse2: `${P}/IMG_3503.JPEG`,
  pathInField: `${P}/IMG_1996.JPEG`,
  winterCabin: `${P}/IMG_4432.JPEG`,
  treeInField: `${P}/IMG_4725.JPEG`,
  picnicView: `${P}/IMG_5246.JPEG`,
  fieldPicnic: `${P}/IMG_6219.JPEG`,

  // ===== COTTAGE PHOTOS (Squarespace CDN — until new cottage photography) =====
  hilltop: `${CDN}/47744b04-b6bf-4e12-8612-0c3f874e1e56/02_BBF_HouseOnHill_003.jpg`,
  hilltopAlt: `${CDN}/58d70c1f-441e-413a-9185-4785b89091bf/02_BBF_HouseOnHill_016.jpg`,
  hilltopSunset: `${CDN}/35bb0d16-453b-46d1-9bdb-0197c610b7ab/02_BBF_HouseOnHill_007.jpg`,
  creekside: `${CDN}/a9f5d4d4-b1c3-44f0-a7e0-65159752d3ef/07_BBF_CreekSide_004.jpg`,
  creeksideAlt: `${CDN}/2aecc319-bffa-45b4-be9a-b17c337a4d2d/07_BBF_CreekSide_001.jpg`,
  pondCottage: `${CDN}/2ee4565d-da90-42f5-a42c-85880acad408/06_BBF_PondCottage_003.jpg`,
  pondCottageAlt: `${CDN}/edc1ec74-fba9-4af8-b614-0e8a8abe9462/06_Pond_Cottage_0305.jpg`,
  gardenCottage: `${CDN}/3b87b2c2-3bf6-4a77-b59b-b9f2d6ae01fe/05_BBF_Garden_001.jpg`,
  gardenCottageAlt: `${CDN}/dea4c220-30d1-4da9-8bac-58defdcb9d89/05_BBF_Garden_008.jpg`,
  granary: `${CDN}/3866c489-9570-4767-b809-dfb8912041d2/03_Granary_0086.jpg`,
  granaryAlt: `${CDN}/c0bbdfc5-ed50-4096-b9c2-065c58276e8e/03_Granary_0100.jpg`,
  barnSuite: `${CDN}/11079f83-0fa7-42c7-aef4-c43b77dd6bf6/11_Barn_Suite_0416.jpg`,
  barnSuiteAlt: `${CDN}/97c28280-533d-4568-88e2-c33ca5706e6a/11_Barn_Suite_0427.jpg`,

  // ===== Backwards-compat aliases (used across pages) =====
  historicBarn: `${P}/IMG_2122.JPEG`,
  lodgingInterior: `${P}/IMG_4914.JPEG`,
  natureRetreat: `${P}/IMG_5145.JPEG`,
  restorativeYoga: `${P}/IMG_6514.JPEG`,
  horsePasture: `${P}/IMG_2126.JPEG`,
  trail: `${P}/IMG_1996.JPEG`,
  garden: `${P}/IMG_6507.JPEG`,
  fireplace: `${P}/IMG_4914.JPEG`,
  morningCoffee: `${P}/IMG_5675.JPEG`,
  candles: `${P}/IMG_4914.JPEG`,
  forest: `${P}/IMG_4945.JPEG`,
  meditation: `${P}/IMG_6336.JPEG`,
  countryRoad: `${P}/IMG_1996.JPEG`,
  sheep: `${P}/IMG_6343.JPEG`,
  miscNature: `${P}/IMG_5170.JPEG`,
  mainHouseExterior: `${P}/IMG_5145.JPEG`,
  mainHouseHero: `${P}/IMG_5145.JPEG`,
  property1: `${P}/IMG_2122.JPEG`,
  property2: `${P}/IMG_5170.JPEG`,
  property3: `${P}/IMG_2126.JPEG`,
  property4: `${P}/IMG_5750.JPEG`,
  property5: `${P}/IMG_5144.JPEG`,
  property6: `${P}/IMG_2124.JPEG`,
  property7: `${P}/IMG_2257.JPEG`,
  mainHouse1: `${P}/IMG_5145.JPEG`,
  mainHouse2: `${P}/IMG_5144.JPEG`,
  mainHouse3: `${P}/IMG_2126.JPEG`,
  barn1: `${P}/IMG_5170.JPEG`,
  barn2: `${P}/IMG_2122.JPEG`,
  barn3: `${P}/IMG_2124.JPEG`,
  wedding1: `${P}/IMG_5145.JPEG`,
  wedding2: `${P}/IMG_5144.JPEG`,
  wedding3: `${P}/IMG_5170.JPEG`,
  wedding4: `${P}/IMG_5169.JPEG`,
  wedding5: `${P}/IMG_2122.JPEG`,

  // ===== MLS PROPERTY PHOTOS (professional listing photos, watermark cropped) =====
  mlsAerial: "/photos/mls/2.jpg",
  mlsMistyHills: "/photos/mls/4.jpg",
  mlsGoldenHourSnow: "/photos/mls/11.jpg",
  mlsHilltopOverview: "/photos/mls/24.jpg",
  mlsPondLilies: "/photos/mls/3.jpg",
  mlsGarden9: "/photos/mls/9.jpg",
  mlsGarden10: "/photos/mls/10.jpg",
  mlsGarden8: "/photos/mls/8.jpg",
  mlsBoardwalk: "/photos/mls/6.jpg",
  mlsWoodenBridge: "/photos/mls/7.jpg",
  mlsRedBarn: "/photos/mls/18.jpg",
  mlsYogaMats: "/photos/mls/13.jpg",
  mlsYogaMats2: "/photos/mls/14.jpg",
  mlsGym: "/photos/mls/15.jpg",
  mlsCottage1: "/photos/mls/1.jpg",
  mlsCottage25: "/photos/mls/25.jpg",
  mlsCottage26: "/photos/mls/26.jpg",
  mlsCottage27: "/photos/mls/27.jpg",
};

// The cottages available for rent at Iron Talon Farm, plus The Barn as common-space amenity.
// Note: The main house is NOT publicly rented (under renovation / private use).
// Booking is handled via inquiry for now; Airbnb / VRBO links will be added when listings go live.
// To wire up direct bookings: add `airbnbUrl` and/or `vrboUrl` to any cottage
// below. When set, "Reserve on Airbnb / VRBO" buttons replace the "Inquire"
// CTA on the Stay page. Leave undefined to show the inquiry button.
export const COTTAGES = [
  {
    slug: "hilltop-cottage",
    name: "Hilltop Cottage",
    tagline: "A secluded, off-grid retreat with 360° views",
    sleeps: "Up to 2",
    image: IMAGES.imgHilltopSunsetBenches,
    imageAlt: IMAGES.imgHillCottExt,
    description:
      "Perched on the highest point of the property, Hilltop Cottage offers amazing 360-degree views of the Pinnacle, Hawk Mountain, and the Blue Ridge Range. A cozy, off-grid retreat with a queen bed, solar lighting only, a small private porch, a private fire pit and picnic table, and the kind of night sky most people forget exists.",
    amenities: ["Queen bed", "360° mountain views", "Solar lighting only", "Outhouse", "Small private porch", "Private fire pit", "Picnic table", "Bird-watching", "Off-grid", "Star gazing"],
    gallery: [
      IMAGES.imgHilltopSunsetBenches,
      IMAGES.imgHilltopSnowyWarm,
      IMAGES.imgHilltopWindowWinter,
      IMAGES.imgHilltopIntCabin,
      IMAGES.imgHilltopIntBed,
      IMAGES.imgHillCottExt,
      IMAGES.imgHilltop6,
      IMAGES.imgHillCottPath,
      IMAGES.newView04,
      IMAGES.newView05,
      IMAGES.driveView04,
      IMAGES.newView08,
      IMAGES.hilltopSunset,
    ],
  },
  {
    slug: "creekside-cottage",
    name: "Creekside Cottage",
    tagline: "A charming hideaway along Little Pine Creek",
    sleeps: "Up to 2",
    image: IMAGES.imgCreeksideCoverNew,
    imageAlt: IMAGES.imgCreeksideBoardwalk,
    description:
      "Nestled alongside Little Pine Creek with a private screened-in porch and a dock leading directly to the water. The kind of quiet only moving water gives you.",
    amenities: ["1 bedroom", "Heat / AC", "Outdoor shower", "Indoor water & sink", "Access to private bath/shower/toilet (in the barn)", "Screened porch", "Creek dock", "Fire pit", "Wi-Fi upon request"],
    gallery: [
      IMAGES.imgCreeksideCoverNew,
      IMAGES.imgCreeksideShed,
      IMAGES.imgCreeksideShedTable,
      IMAGES.imgCreeksideIntBed,
      IMAGES.imgCreeksideIntRocker,
      IMAGES.imgCreeksideBoardwalk,
      IMAGES.imgCreeksideCreek,
      IMAGES.imgCreeksideShower,
      IMAGES.imgBathhouse1,
      IMAGES.pondClearStream,
    ],
    sharedBath: true,
  },
  {
    slug: "cattail-cottage",
    name: "Cattail Cottage",
    tagline: "A historic outbuilding overlooking the pond",
    sleeps: "Up to 2",
    image: IMAGES.pondCottageAlt,
    imageAlt: IMAGES.imgCattailIntUser1,
    description:
      "Built in the mid-to-late 1800s and once a milk house — later a welding shop — Cattail Cottage is the largest and most centrally located cottage on the property, with original rough-cut beams, wood planks, and views over the pond. A king bed, a gas fireplace for cool nights, and a quiet that settles in with the cattails.",
    amenities: ["1 bedroom", "King bed", "Gas fireplace", "AC", "Access to private bath/shower/toilet (in the barn)", "Pond view", "Fire pit", "Wi-Fi upon request"],
    gallery: [
      IMAGES.imgCattailFront,
      IMAGES.imgCattailOutsideUser,
      IMAGES.imgCattailIntUser1,
      IMAGES.imgCattailIntUser2,
      IMAGES.imgOverviewCattail3,
      IMAGES.pondCottageAlt,
      IMAGES.imgCattailInt,
      IMAGES.imgBathhouse2,
      IMAGES.drivePond08,
      IMAGES.drivePond10,
    ],
    sharedBath: true,
  },
  {
    slug: "garden-cottage",
    name: "Garden Cottage",
    tagline: "The former summer kitchen — now a peaceful two-bedroom duplex",
    sleeps: "Up to 4",
    image: IMAGES.gardenCottage,
    imageAlt: IMAGES.imgGardenCott1,
    description:
      "Once the summer kitchen, Garden Cottage is a comfortable two-bedroom duplex with two queen beds — best for families and small parties who want a little more room to spread out. It sits right beside the vegetable garden, so mornings often start with a wander through the raised beds.",
    amenities: ["2 bedrooms", "2 queen beds", "Heat / AC", "Private bath with walk-in shower", "Steps from the vegetable garden", "Wi-Fi upon request"],
    gallery: [
      IMAGES.imgVegGardenHenDenHD,
      IMAGES.imgGardenCott1,
      IMAGES.imgGardenCott2,
      IMAGES.imgGardenCott3,
      IMAGES.imgGardenCott4,
      IMAGES.gardenCottage,
      IMAGES.gardenCottageAlt,
    ],
  },
  {
    slug: "the-granary",
    name: "The Granary",
    tagline: "A historic grain shed, now a cozy hideaway",
    sleeps: "Up to 2",
    image: IMAGES.granary,
    imageAlt: IMAGES.imgGranary3,
    description:
      "Once a grain shed, the Granary retains its historic charm with original wood floors, walls, and ceilings. Queen bed, private deck, and close to the common kitchen.",
    amenities: ["1 bedroom", "Queen bed", "Heat / AC", "Private deck", "Access to private bath/shower/toilet (in the barn)", "Kitchen access", "Wi-Fi upon request"],
    gallery: [
      IMAGES.granary,
      IMAGES.imgGranaryWoodStove,
      IMAGES.imgGranaryPhoneCottage,
      IMAGES.imgGranary2,
      IMAGES.imgGranary3,
      IMAGES.imgGranary5,
      IMAGES.granaryAlt,
      IMAGES.imgGranaryExt,
      IMAGES.imgBathhouseSink,
      IMAGES.imgGranary4,
    ],
    sharedBath: true,
  },
  {
    slug: "loft-cottage",
    name: "Loft Cottage",
    tagline: "Perched over a small mountain stream",
    sleeps: "Up to 2",
    image: IMAGES.imgGardenBridge,
    imageAlt: IMAGES.imgLoftFrontPorch,
    description:
      "A small, sun-filled loft perched above its own mountain stream — separate from Little Pine Creek. Queen bed, a small kitchen, and a private bathroom with a clawfoot tub — a quiet self-contained retreat.",
    amenities: ["Queen bed", "Heat / AC", "Small kitchen", "Private bathroom with clawfoot tub", "Mountain stream below", "Wi-Fi upon request"],
    gallery: [
      IMAGES.imgGardenBridge,
      IMAGES.imgLoftFrontPorch,
      IMAGES.imgLoftExterior,
      IMAGES.imgLoftInterior,
      IMAGES.imgLoftKitchen,
      IMAGES.imgLoftBath,
    ],
  },
];

// Wedding, event, and retreat packages — pricing from the existing site.
export const WEDDING_PACKAGES = [
  { name: "Day Use", price: "$3,500", desc: "A one-day micro-wedding: barn, grounds, kitchen, bridal suite, 2-hour rehearsal." },
  { name: "One Night", price: "$4,500", desc: "Day Use + overnight stay for up to 16 in the seven cottages, with breakfast." },
  { name: "Two Nights", price: "$5,750", desc: "A long weekend with your closest people — celebrate, sleep, repeat." },
  { name: "Three Nights", price: "$6,900", desc: "An immersive wedding weekend with all the breathing room you'd want." },
];

export const EVENT_PACKAGES = [
  { name: "Three-Hour Event", price: "$750", desc: "Barn Commons for up to 50 guests. Kitchen, deck, patio." },
  { name: "Full-Day Rental", price: "$1,200", desc: "All common areas for the day, up to 50 guests. Retreats, gatherings, milestones." },
];

export const RETREAT_PACKAGES = [
  { name: "One or Two Nights", price: "$2,000 / night", desc: "Entire property for up to 16 — 7 cottages, common areas, full kitchen." },
  { name: "Three or More Nights", price: "$1,850 / night", desc: "Multi-night use of the whole farm — perfect for wellness, family, or off-sites." },
];

export const TESTIMONIAL = {
  quote:
    "Iron Talon Farm is the perfect retreat from the stress and anxiety that comes with modern living. The hosts could not have been more helpful, and ensured we had everything we needed for our trip, and were there to answer every question we had.",
  author: "Walter",
  location: "New York",
};

export const NOUWEN_QUOTE = {
  quote: "A man does not recover by escaping the fight. He recovers by stepping back long enough to remember why he stands.",
  author: null,
};
